export const TASK = 'task';
export const ABSTRACT_TASK = 'abstract';
export const USER_TASK = 'user';
export const MANUAL_TASK = 'manual';
export const SERVICE_TASK = 'service';
export const SCRIPT_TASK = 'script';
export const BUSINESS_RULE_TASK = 'business-rule';
export const SUBPROCESS = 'embedded-subprocess';
export const ALL_TASKS = [ABSTRACT_TASK, USER_TASK, MANUAL_TASK, SERVICE_TASK, SCRIPT_TASK, BUSINESS_RULE_TASK, SUBPROCESS];

export const EVENT = 'event';
export const START_EVENT = 'startEvent';
export const END_EVENT = 'endEvent';
export const TIMER_EVENT = 'timer';
export const MESSAGE_SEND_EVENT = 'messageSend';
export const MESSAGE_RECEIVE_EVENT = 'messageReceive';
export const DEFAULT_EVENT = 'default';


export const ALL_EVENTS = [MESSAGE_SEND_EVENT, MESSAGE_RECEIVE_EVENT, TIMER_EVENT];

export const LOOP = 'loop';
export const EXCLUSIVE_GATEWAY = 'xor';
export const PARALLEL_GATEWAY = 'parallel';
export const EVENT_BASED_GATEWAY = 'events-gateway';
export const ALL_GATEWAYS = [LOOP, EXCLUSIVE_GATEWAY, PARALLEL_GATEWAY, EVENT_BASED_GATEWAY];

export const DATA_OBJECT = 'data-file';
export const DATA_STORE =  'data-store';

export const MULTIPLE_POOLS = 'multiple-pools';

export const WAYPOINT = 'waypoint';
